import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import LazyLoaderWrapper from 'atoms/LazyLoaderWrapper';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { DISPOSITION_KEYS, CHECKOUT_CONSTANTS } from 'common/constants/SharedConstants';
import { getAndCheck, getTernaryValue, isPickupDisposition, safeUpperCase } from 'common/utilities/utils';
import { updateDispositionOptions, validateCheckoutDetails } from 'common/utilities/CheckoutUtils';

const radioBtnChangeHandler = (checkoutDetails, updateCheckoutDetails) => {
  const radioChangeValue = getTernaryValue(
    checkoutDetails?.userOption === CHECKOUT_CONSTANTS?.LEAVE_AT_MY_DOOR,
    CHECKOUT_CONSTANTS?.HAND_IT_TO_ME,
    CHECKOUT_CONSTANTS?.LEAVE_AT_MY_DOOR,
  );
  updateCheckoutDetails({
    userOption: radioChangeValue,
    userInformation: {
      ...CHECKOUT_CONSTANTS?.FORM_FIELD_DEFAULT_VALUE,
      error: getAndCheck(
        isPickupDisposition(checkoutDetails?.service),
        radioChangeValue === CHECKOUT_CONSTANTS?.LEAVE_AT_MY_DOOR,
      ),
    },
  });
};

const typeOptions = info_type => {
  switch (safeUpperCase(info_type)) {
    case DISPOSITION_KEYS.DELIVERY:
      return TRANSLATE_MAPPING_KEY.DELIVERY_OPTIONS;
    case DISPOSITION_KEYS.PICKUP:
      return TRANSLATE_MAPPING_KEY.TAKEAWAY_OPTIONS;
    case DISPOSITION_KEYS.DINE_IN:
      return TRANSLATE_MAPPING_KEY.DINEIN_OPTIONS;
    // no default
  }
};

const kfcToCarCollectionPointCheck = (availableCollection, type) => {
  const { CURB_SIDE } = CHECKOUT_CONSTANTS;
  return isPickupDisposition(type)
    ? Array.isArray(availableCollection) &&
        availableCollection.length > 0 &&
        Boolean(availableCollection.find(collection => collection.collectionPointName === CURB_SIDE))
    : true;
};

const getCheckoutDispositionOptionsItem = (props, cartReducer) => {
  return (
    <LazyLoaderWrapper
      {...props}
      testId='CheckoutDispositionOptionsItem'
      importPath='CHECKOUT_DISPOSITION_OPTIONS_VIEW'
      cartReducer={cartReducer}
      typeOptions={typeOptions}
      kfcToCarCollectionPointCheck={kfcToCarCollectionPointCheck}
      radioBtnChangeHandler={radioBtnChangeHandler}
      updateDispositionOptions={event =>
        updateDispositionOptions(event, props.checkoutDetails, props.updateCheckoutDetails)
      }
    ></LazyLoaderWrapper>
  );
};

const CheckoutDispositionOptions = props => {
  const { cartReducer } = useSelector(data => data);
  const { checkoutDetails, updateCheckoutDetails } = props;
  const { userInformation, userOption,userParams } = checkoutDetails;

  // here we will validate the data and enable payment button based on required data
  useEffect(() => {
    const updatedCheckoutDetails = {
      ...checkoutDetails, guestCheckOutFieldsValidated: userParams?.loggedIn ?
        userParams?.loggedIn : checkoutDetails?.guestCheckOutFieldsValidated
    };
    validateCheckoutDetails(updatedCheckoutDetails, updateCheckoutDetails);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userInformation, userOption]);

  return getCheckoutDispositionOptionsItem(props, cartReducer);
};

export default CheckoutDispositionOptions;
